import Form, { FormProps } from "../form/form";
import { ISearchStyles, useSearchStyles } from "../../layouts";
import { FormikProps } from "formik";

interface SearchContainerProps extends FormProps {
    controlStyles?: ISearchStyles | undefined;
    onSearch?: (values: any) => void;
    onClear?: () => void;
    onNew?: () => void;
}

export const SearchContainer: React.FC<SearchContainerProps> = (props) => {
    const styles: ISearchStyles = props.controlStyles ?? useSearchStyles();
    const displaySearch = (props.children && props.onSearch);
    const hasStyledActions = !!styles.actionsContainer;
    const searchButtonClassName = hasStyledActions ? "btn jump-on-hover" : "btn mb-1 ms-2 px-4 jump-on-hover";
    const clearButtonClassName = hasStyledActions ? "btn jump-on-hover" : "btn mb-1 ms-2 px-3 jump-on-hover";

    return (
        <Form
            onSubmit={(values) => {
                props.onSearch?.(values);
            }}
            initialValues={props.initialValues}
            enableReinitialize={props.enableReinitialize}
        >
            {(formik: FormikProps<any>) => (
                <div
                    className="d-flex flex-row search-container"
                    style={styles.searchContainer}
                >
                    <div className="flex-fill">
                        {displaySearch && (
                            <div className="d-flex flex-wrap ms-0" style={styles.fieldsContainer}>
                                {typeof props.children === "function"
                                    ? props.children(formik)
                                    : props.children}
                            </div>
                        )}
                    </div>
                    {displaySearch && (
                        <div className="ml-auto" style={styles.actionsContainer}>
                            <Form.Button className={searchButtonClassName} type="submit" style={{ ...styles.button, ...styles.searchButton }} >
                                <span className="bi bi-search" style={styles.icon} />
                            </Form.Button>
                            {props.onClear && (
                                <Form.Button
                                    type="button"
                                    onClick={() => {
                                        props?.onClear?.();
                                        formik.resetForm();
                                    }}
                                    className={clearButtonClassName}
                                    style={{ ...styles.button, ...styles.clearButton }}
                                >
                                    Clear
                                </Form.Button>
                            )}
                            {props.onNew && (
                                <Form.Button
                                    className="btn jump-on-hover"
                                    style={{ ...styles.button, ...styles.newButton }}
                                    onClick={props.onNew}
                                    type="button"
                                >
                                    <span className="bi bi-plus" style={styles.icon}></span>New
                                </Form.Button>
                            )}
                        </div>
                    )}
                    {!displaySearch && props.onNew && (
                        <div className="ml-auto  ms-2" style={styles.newActionContainer}>
                            <Form.Button
                                className="btn jump-on-hover"
                                style={{ ...styles.button, ...styles.newButton }}
                                onClick={props.onNew}
                                type="button"
                            >
                                <span className="bi bi-plus" style={styles.icon}></span>New
                            </Form.Button>
                        </div>
                    )}
                </div>
            )}
        </Form>
    );
};
